/**
 * @generated by `astryx theme build` — do not edit manually.
 * Source: src/psychometricsTheme.ts
 * Command: astryx theme build src/psychometricsTheme.ts --out src/psychometrics-theme.css
 * Generated: 2026-07-23T13:05:13.222Z
 */

/**
 * psychometrics-matcha theme — built by `bunx astryx theme build`
 * Import the CSS file alongside this module:
 *
 *   import { psychometricsMatchaTheme } from './psychometrics-matcha';
 *   import './psychometrics-matcha.css';
 */
export const psychometricsMatchaTheme = {
  name: 'psychometrics-matcha',
  __built: true,
  tokens: {
    "--font-size-4xs": "0.375rem",
    "--font-size-3xs": "0.4375rem",
    "--font-size-2xs": "0.5rem",
    "--font-size-xs": "0.625rem",
    "--font-size-sm": "0.75rem",
    "--font-size-base": "0.9375rem",
    "--font-size-lg": "1.125rem",
    "--font-size-xl": "1.375rem",
    "--font-size-2xl": "1.6875rem",
    "--font-size-3xl": "2.0625rem",
    "--font-size-4xl": "2.5625rem",
    "--font-size-5xl": "3.0625rem",
    "--text-heading-1-size": "var(--font-size-2xl)",
    "--text-heading-1-weight": "var(--font-weight-semibold)",
    "--text-heading-1-leading": "1.3333",
    "--text-heading-2-size": "var(--font-size-xl)",
    "--text-heading-2-weight": "var(--font-weight-semibold)",
    "--text-heading-2-leading": "1.4545",
    "--text-heading-3-size": "var(--font-size-lg)",
    "--text-heading-3-weight": "var(--font-weight-semibold)",
    "--text-heading-3-leading": "1.5556",
    "--text-heading-4-size": "var(--font-size-base)",
    "--text-heading-4-weight": "var(--font-weight-semibold)",
    "--text-heading-4-leading": "1.6",
    "--text-heading-5-size": "var(--font-size-sm)",
    "--text-heading-5-weight": "var(--font-weight-semibold)",
    "--text-heading-5-leading": "1.6667",
    "--text-heading-6-size": "var(--font-size-xs)",
    "--text-heading-6-weight": "var(--font-weight-semibold)",
    "--text-heading-6-leading": "1.6",
    "--text-body-size": "var(--font-size-base)",
    "--text-body-weight": "var(--font-weight-normal)",
    "--text-body-leading": "1.6",
    "--text-large-size": "var(--font-size-lg)",
    "--text-large-weight": "var(--font-weight-semibold)",
    "--text-large-leading": "1.5556",
    "--text-label-size": "var(--font-size-base)",
    "--text-label-weight": "var(--font-weight-medium)",
    "--text-label-leading": "1.6",
    "--text-code-size": "var(--font-size-base)",
    "--text-code-weight": "var(--font-weight-normal)",
    "--text-code-leading": "1.6",
    "--text-supporting-size": "var(--font-size-sm)",
    "--text-supporting-weight": "var(--font-weight-normal)",
    "--text-supporting-leading": "1.6667",
    "--text-display-1-size": "var(--font-size-5xl)",
    "--text-display-1-weight": "var(--font-weight-normal)",
    "--text-display-1-leading": "1.2245",
    "--text-display-2-size": "var(--font-size-4xl)",
    "--text-display-2-weight": "var(--font-weight-normal)",
    "--text-display-2-leading": "1.2683",
    "--text-display-3-size": "var(--font-size-3xl)",
    "--text-display-3-weight": "var(--font-weight-normal)",
    "--text-display-3-leading": "1.2121",
    "--duration-fast-min": "105ms",
    "--duration-fast": "140ms",
    "--duration-fast-max": "185ms",
    "--duration-medium-min": "240ms",
    "--duration-medium": "320ms",
    "--duration-medium-max": "425ms",
    "--duration-slow-min": "570ms",
    "--duration-slow": "760ms",
    "--duration-slow-max": "1015ms",
    "--font-family-body": "Figtree, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
    "--font-family-heading": "Figtree, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif",
    "--font-family-code": "\"JetBrains Mono\", \"SF Mono\", Monaco, Consolas, monospace",
    "--color-syntax-keyword": "light-dark(#700084, #efa8ff)",
    "--color-syntax-string": "light-dark(#005600, #a6d2a2)",
    "--color-syntax-comment": "light-dark(#737373, #a3a3a3)",
    "--color-syntax-number": "light-dark(#6e3500, #ffb37f)",
    "--color-syntax-function": "light-dark(#00458c, #a0caff)",
    "--color-syntax-type": "light-dark(#700084, #efa8ff)",
    "--color-syntax-variable": "light-dark(#171717, #e5e5e5)",
    "--color-syntax-operator": "light-dark(#737373, #a3a3a3)",
    "--color-syntax-constant": "light-dark(#6e3500, #ffb37f)",
    "--color-syntax-tag": "light-dark(#89001a, #ffaeaa)",
    "--color-syntax-attribute": "light-dark(#584400, #eec12f)",
    "--color-syntax-property": "light-dark(#005348, #83dac9)",
    "--color-syntax-punctuation": "light-dark(#a3a3a3, #525252)",
    "--color-syntax-background": "light-dark(#fafafa, #0a0a0a)",
    "--color-background-surface": "light-dark(#FCFCF9, #1A1E16)",
    "--color-background-body": "light-dark(#F4F5EF, #12150F)",
    "--color-background-card": "light-dark(#FFFFFF, #20251B)",
    "--color-background-popover": "light-dark(#ffffff, #1b1b1b)",
    "--color-background-muted": "light-dark(#EBEEE3, #293022)",
    "--color-accent": "light-dark(#41552D, #C2D3A8)",
    "--color-accent-muted": "light-dark(#41552D17, #C2D3A824)",
    "--color-neutral": "light-dark(#0000000F, #FFFFFF1A)",
    "--color-overlay": "light-dark(#00000080, #000000CC)",
    "--color-overlay-hover": "light-dark(#0000000D, #FFFFFF0D)",
    "--color-overlay-pressed": "light-dark(#0000001A, #FFFFFF1A)",
    "--color-text-primary": "light-dark(#20281A, #E8EDD9)",
    "--color-text-secondary": "light-dark(#66705C, #AAB59A)",
    "--color-text-disabled": "light-dark(#a3a3a3, #525252)",
    "--color-text-accent": "light-dark(#41552D, #C2D3A8)",
    "--color-on-dark": "#ffffff",
    "--color-on-light": "#171717",
    "--color-on-accent": "light-dark(#FFFFFF, #243019)",
    "--color-on-success": "light-dark(#ffffff, #171717)",
    "--color-on-error": "light-dark(#ffffff, #171717)",
    "--color-on-warning": "#171717",
    "--color-icon-accent": "light-dark(#41552D, #C2D3A8)",
    "--color-icon-primary": "light-dark(#171717, #fafafa)",
    "--color-icon-secondary": "light-dark(#737373, #a3a3a3)",
    "--color-icon-disabled": "light-dark(#a3a3a3, #525252)",
    "--color-success": "light-dark(#4F6B34, #9DBB7C)",
    "--color-error": "light-dark(#a50c25, #ffc6c1)",
    "--color-warning": "light-dark(#745b00, #fdcf4f)",
    "--color-success-muted": "light-dark(#4F6B3420, #9DBB7C24)",
    "--color-error-muted": "light-dark(#facecb, #ff9e973D)",
    "--color-warning-muted": "light-dark(#f8da9d, #deb4333D)",
    "--color-border": "light-dark(#DDE2D3, #343D2B)",
    "--color-border-emphasized": "light-dark(#C2CBB5, #4B5840)",
    "--color-skeleton": "light-dark(#ebebeb, #525252)",
    "--color-shadow": "light-dark(#41552D1A, #0000004D)",
    "--color-tint-hover": "light-dark(black, white)",
    "--color-background-red": "light-dark(#facecb, #ff9e973D)",
    "--color-border-red": "light-dark(#e6bab8, #ff6f6c)",
    "--color-icon-red": "light-dark(#89001a, #ff9e97)",
    "--color-text-red": "light-dark(#89001a, #ffc6c1)",
    "--color-background-orange": "light-dark(#fad0b5, #ffa2583D)",
    "--color-border-orange": "light-dark(#e6bda2, #e2883e)",
    "--color-icon-orange": "light-dark(#6e3500, #ffa258)",
    "--color-text-orange": "light-dark(#6e3500, #ffc9a2)",
    "--color-background-yellow": "light-dark(#f8da9d, #deb4333D)",
    "--color-border-yellow": "light-dark(#e4c279, #c0990e)",
    "--color-icon-yellow": "light-dark(#584400, #deb433)",
    "--color-text-yellow": "light-dark(#584400, #fdcf4f)",
    "--color-background-green": "light-dark(#4F6B3417, #9DBB7C24)",
    "--color-border-green": "light-dark(#718858, #9DBB7C)",
    "--color-icon-green": "light-dark(#0c5700, #84c980)",
    "--color-text-green": "light-dark(#3D5528, #C7DBAF)",
    "--color-background-teal": "light-dark(#a5e3d6, #7ec6b83D)",
    "--color-border-teal": "light-dark(#94d6c8, #63ab9d)",
    "--color-icon-teal": "light-dark(#005348, #7ec6b8)",
    "--color-text-teal": "light-dark(#005348, #99e2d3)",
    "--color-background-cyan": "light-dark(#a3e0ef, #83c2d43D)",
    "--color-border-cyan": "light-dark(#91d3e3, #67a7b8)",
    "--color-icon-cyan": "light-dark(#00505f, #83c2d4)",
    "--color-text-cyan": "light-dark(#00505f, #9edef0)",
    "--color-background-blue": "light-dark(#c4ddfb, #9eb7ff3D)",
    "--color-border-blue": "light-dark(#b1c9e7, #6d9cfe)",
    "--color-icon-blue": "light-dark(#00458c, #9eb7ff)",
    "--color-text-blue": "light-dark(#00458c, #c7d3ff)",
    "--color-background-purple": "light-dark(#eccef3, #f297ff3D)",
    "--color-border-purple": "light-dark(#d8bbdf, #dd74f0)",
    "--color-icon-purple": "light-dark(#700084, #f297ff)",
    "--color-text-purple": "light-dark(#700084, #fac1ff)",
    "--color-background-pink": "light-dark(#fccadc, #ff99c33D)",
    "--color-border-pink": "light-dark(#e7b7c8, #f273aa)",
    "--color-icon-pink": "light-dark(#83004b, #ff99c3)",
    "--color-text-pink": "light-dark(#83004b, #ffc3da)",
    "--color-background-gray": "light-dark(#e5e5e5, var(--color-neutral))",
    "--color-border-gray": "light-dark(#d4d4d4, #262626)",
    "--color-icon-gray": "light-dark(#525252, #a3a3a3)",
    "--color-text-gray": "light-dark(#262626, #e5e5e5)",
    "--radius-none": "0.25rem",
    "--radius-inner": "5px",
    "--radius-element": "9px",
    "--radius-container": "16px",
    "--radius-page": "24px",
    "--radius-full": "9999px",
    "--shadow-low": "0 1px 2px #41552D0D, 0 8px 24px #41552D0A",
    "--shadow-med": "0 2px 4px #41552D12, 0 14px 36px #41552D12",
    "--shadow-high": "0 4px 8px #41552D14, 0 24px 56px #41552D1A",
    "--shadow-inset-hover": "inset 0px 0px 0px 2px #0074e24D",
    "--shadow-inset-selected": "inset 0px 0px 0px 2px #0074e280",
    "--shadow-inset-success": "inset 0px 0px 0px 2px #1981004D",
    "--shadow-inset-warning": "inset 0px 0px 0px 2px #ffce2f4D",
    "--shadow-inset-error": "inset 0px 0px 0px 2px #e33f4a4D",
    "--color-track": "light-dark(#DDE2D3, #4B5840)",
    "--size-element-sm": "32px",
    "--size-element-md": "38px",
    "--size-element-lg": "44px"
  },

};
